import { useContext } from "react";
import { Container } from "reactstrap";

//Common
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";
import DisplayData from "../../common/DisplayData/DisplayData";
import ActionBar from "../../common/ActionBar/ActionBar";
import { BlockIcon, ActivateIcon } from "../../common/Icons";
import { Button } from "../../common/VFX-UI";
//App
import { CountyContext } from "./CountyContainer";
import useComponentGeneralStyles from "../../styles";
import { EMPTY_GUID } from "../../../utility/constants/constants";
import { CountyViewProps } from "../../../types/county";

const CountyView = (props: CountyViewProps) => {
  const {
    onClose,
    editAction,
    toggleActivateHandler,
    toggleDeactivateHandler,
  } = props;
  const countyContext = useContext(CountyContext);
  const generalStyles = useComponentGeneralStyles();

  const county = countyContext?.data;

  const state = countyContext?.states?.find(
    (state) => (state as Record<string, string>)["value"] === county?.stateId
  );

  return (
    <FormBackGround>
      <FormHeader
        title="View County"
        chipLabel={county?.isActive ? "Active" : "Inactive"}
        onClose={onClose}
        editActionHandler={county?.isActive ? editAction : undefined}
      />
      <>
        <DisplayData text="Name" importedData={county?.name}></DisplayData>
        <DisplayData
          text="Description"
          importedData={county?.description}
        ></DisplayData>
        <DisplayData
          text="State"
          importedData={(state as Record<string, string>)["label"]}
        ></DisplayData>
        {county?.id && county?.id !== EMPTY_GUID && county?.isActive && (
          <Container>
            <Button
              style={generalStyles.deleteButton}
              onClick={toggleDeactivateHandler}
            >
              <BlockIcon />
            </Button>
          </Container>
        )}
        {county?.id && county?.id !== EMPTY_GUID && !county?.isActive && (
          <Container>
            <Button
              style={generalStyles.activateButton}
              onClick={toggleActivateHandler}
            >
              <ActivateIcon />
            </Button>
          </Container>
        )}
      </>
      <Container style={generalStyles.actionBarContainer}>
        <ActionBar cancelHandler={onClose} cancelText="Close"></ActionBar>
      </Container>
    </FormBackGround>
  );
};

export default CountyView;
